export class TargetAchievementModel {
  id: Number;
  program_id: Number;
  created_by: Number;
  updated_by: Number;
  target_status: Number;
  frequency_id: Number;
  frequency_name: String;
  is_trigger: Number;
  target_img: any;
  target_description: String;
  terms_conditions: String;
  eligibility: String;
  winner_message: String;
  winner_message_image: String;
  loser_message: String;
  loser_message_image: String;
  announcement_image: any;
  announcement_button_text: String;
  results_image: String;
  results_button_text: String;
  module_enabled: String;
  module_expired: String;
  created_date: String;
  updated_date: String;
  start_date: any ={};
  sel_month:any;
  sel_year:any;
  end_date: any;
  target_title: String;
  sku_based: any;
  status : any;
}

export class UserTargetAndPointStructureModel {
  excel_data: any[];
  point_structure: PointStructureModel[];
  point_excel_data: any[];
  region_id: any;
  channel_id: any;
  id: Number;
  sku_based: any;
  state_id:any;
  points_based:any;
}
export class PointStructureModel {
  id: Number;
  user_role_id: Number;
  user_role_name: String;
  brand_id: Number;
  brand_name: String;
  geographical_id: Number;
  channel_id: Number;
  channel_name: String;
  points: Number;
  status: Number;
  category_id: Number;
  category_name: String;
  region_id: Number;
  region_name: String;
  qty: Number;
  unit_id: Number;
  unit_name: String;
  target_id: Number;
  conditional_operator: String;
  isEdit: boolean;
  user_name: string;
  ro_code: string;
  showEdit: boolean;
  sku_based_point_structure: PointStructureProductWiseModel[];
  showDetail: boolean;
}

export class PointStructureProductWiseModel {
  id: number;
  product_id: number;
  channel_id: number;
  points: number;
  status: number;
  created_date: string;
  updated_date: string;
  category_id: string;
  region_id: string;
  qty: string;
  conditional_operator: string;
  unit_id: number;
  target_id: number;
  points_structure_id: number;
  channel_name: string;
  region_name: string;
  unit_name: string;
  product_code: string;
  product_name: string;
  isEdit: boolean;
}

export class LoyaltyTargetModel {
  id: Number;
  brand_category_id: Number;
  brand_category_name: String;
  short_name: string;
  user_id: Number;
  user_name: String;
  program_id: Number;
  target_qty: Number;
  target_month: Number;
  target_year: Number;
  status: Number;
  target_id: Number;
  created_date: String;
  updated_date: String;
  brand_id: Number;
  brand_name: String;
  isEdit: boolean;
  ro_code: any;
  showDetail: boolean;
  sku_wise_target: LoyaltyTargetProductWiseModel[];
  showEdit: boolean;
  ro_name: string;
}

export class LoyaltyTargetProductWiseModel {
  id: number;
  brand_category_id: number;
  brand_category_name: string;
  user_id: number;
  user_name: string;
  user_role_name: string;
  ro_code: string;
  user_number: string;
  program_id: number;
  target_qty: number;
  target_month: number;
  target_year: string;
  status: number;
  target_id: number;
  created_date: string;
  updated_date: string;
  product_id: string;
  product_code: string;
  product_name: string;
  isEdit: boolean;
  ro_name: string;
}

export class UserSaleAchivementModel {
  achievement_category_data: any[];
  achievement_product_data: any[];
  id: Number;
}

export class SalesAchievementModel {
  id: number;
  category_id: number;
  brand_category_name: string;
  user_id: number;
  user_name: string;
  ro_code: string;
  program_id: string;
  sales_qty: string;
  sales_month: string;
  sales_year: string;
  status: number;
  target_id: number;
  created_date: string;
  updated_date: string;
  brand_id: number;
  brand_name: string;
  approve_status: number;
  isEdit: boolean;
  approved_status_string: string;
  bulkChecked: boolean;
  showCheckBox: boolean;
  sku_wise_sales: SalesAchievementProductWiseModel[];
  showEdit: boolean;
  showDetail: boolean;
  points: number;
}

export class ApprovedAchievementModel {
  task_id: number;
  records: any[];
}

export class SalesAchievementProductWiseModel {
  id: number;
  category_id: number;
  brand_category_name: string;
  user_id: number;
  user_name: string;
  ro_code: string;
  program_id: number;
  sales_qty: number;
  sales_month: number;
  sales_year: string;
  status: number;
  target_id: number;
  created_date: string;
  updated_date: string;
  sales_transactions_cumulative_id: number;
  product_code: string;
  product_name: string;
  ro_name: string;
  isEdit: boolean;
  points: number;
}
